<template>
  <div class="h-full relative">
    <div
      v-if="isVisible"
      class="absolute h-full w-full flex flex-wrap top-0 left-0 overflow-hidden z-40"
    >
      <div class="w-1/2 shadow-lg" :style="{ backgroundColor: bgColor }">
        <div class="flex justify-between px-12 mt-4">
          <RandomText class="text-6xl"></RandomText>
          <div
            @click="infoShow"
            class="flex justify-end cursor-pointer creu-in"
          >
            <Icon icon="iwwa:close" width="55px" weight="light" />
          </div>
        </div>

        <fidelio-process
          :process="process"
          :processInfo="processInfo"
        ></fidelio-process>
      </div>
      <div class="w-1/2 opacity-60" :style="{ backgroundColor: bgColor }">
        <div
          class="w-full h-full opacity-20"
          :style="{ backgroundColor: bgColor }"
        ></div>
      </div>
    </div>
    <div class="flex flex-col h-full justify-between">
      <div class="flex justify-between">
        <div class="flex z-50 items-end p-4">
          <RandomText class="text-3xl">El Modern</RandomText>
          <RandomText class="text-xl text-gray-400 pl-1">
            Developer - Interaction Design
          </RandomText>
        </div>
      </div>
      <div>
        <RandomText class="cursor-pointer text-3xl p-5" @click="processShow"
          >Process</RandomText
        >
      </div>
    </div>

    <slider-projects :slides="slides" />
  </div>
</template>

<script>
import SliderProjects from "@/components/SliderProjects.vue";
import FidelioProcess from "@/components/FidelioProcess.vue";
import RandomText from "@/components/RandomText.vue";

export default {
  name: "App",
  components: {
    SliderProjects,
    FidelioProcess,
    RandomText,
  },
  props: {
    bgColor: {
      type: String,
      required: true,
      default: "rgb(255, 255, 255)",
    },
  },
  data() {
    return {
      isVisible: false,
      slides: [
        {
          type: "text",
          content:
            "Aquest projecte es va desenvolupar dins del Laboratori Playful Living Lab per a l'edifici cultural El Modern de Girona. La premissa consistia a crear un mural interactiu que per una banda, narrés la història de l'edifici i també, es pogués descobrir els seus serveis en l'actualitat. Vaig participar en les fases inicials, des de la recerca i organització de la informació fins a l'exploració de la tecnologia a utilitzar. Posteriorment, l'equip es va dividir en àrees especialitzades, i em vaig enfocar en el desenvolupament digital d'una secció específica del mural.",
        },
        {
          type: "image",
          content: "/img/modern/modern1.png",
        },
        {
          type: "image",
          content: "/img/modern/modern2.png",
        },
        {
          type: "image",
          content: "/img/modern/modern3.png",
        },
        {
          type: "image",
          content: "/img/modern/modern4.png",
        },
      ],
      process: [
        {
          text: "Com vaig esmentar anteriorment, vaig participar en la fase de conceptualització, disseny i desenvolupament d'aquest projecte. La meva responsabilitat principal va ser el desenvolupament digital d'una secció específica del mural, enfocada a exhibir a través d'una pantalla, els serveis actuals de l'edifici El Modern. La informació es mostrava quan els usuaris s'aproximaven a punts específics del mural equipats amb sensors de proximitat.",
        },
        {
          text: "Per al desenvolupament d'això, vaig treballar amb Vue.js, també vaig utilitzar GSAP per a animacions i Socket.io per a la recepció i comunicació de dades rebudes pels sensors.",
        },
      ],
      processInfo: [
        {
          title: "Client:",
          subtitle: "Pied de Biche & Choeur Auguste",
        },
        {
          title: "Location:",
          subtitle: "Le Centre Culturel des Terreaux, Lausanne",
        },
        {
          title: "Direction:",
          subtitle: "Julie Burnier",
        },
        {
          title: "Choreography:",
          subtitle: "Judith Desse",
        },
        {
          title: "Scenography and costumes:",
          subtitle: "Anna Jones",
        },
        {
          title: "Light:",
          subtitle: "David Baumgartner",
        },
        {
          title: "Photography:",
          subtitle: "Sylvain Chabloz",
        },
      ],
    };
  },
  methods: {
    processShow() {
      this.isVisible = !this.isVisible;
    },
    infoShow() {
      this.isVisible = !this.isVisible;
    },
  },
};
</script>

<style>
.creu-in {
  animation: fadeInOut 5s ease-in-out infinite;
}

@keyframes fadeInOut {
  0% {
    transform: translateY(0) scale(0.7);
    opacity: 100%;
  }
  50% {
    transform: translateY(90vh) scale(0.2);
    opacity: 0%;
  }
  100% {
    transform: translateY(0) scale(0.7);
    opacity: 100%;
  }
}
</style>

